module.exports = __webpack_public_path__ + "img/minus-button.b1dca5f0.svg";